import { comprehensiveVocabulary } from './comprehensiveVocabulary';
import { vocabularyPart2 } from './vocabularyPart2';

// Combine all vocabulary parts
export const allVocabulary = [
  ...comprehensiveVocabulary,
  ...vocabularyPart2
];

// Export the combined vocabulary
export { comprehensiveVocabulary, vocabularyPart2 }; 